import random from 'lodash/random';

/**
 * A helper that returns a random seller id
 * @returns a random id
 */
export const getSellerId = () => `${new Date().getTime().toString()}-${random(0, 1000).toString()}`;
